document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.mobile-mega-menu__tabs .tab');
  const underline = document.querySelector('.mobile-mega-menu__tabs .tab-underline');
  const contents = document.querySelectorAll('.mobile-mega-menu__content');
  const live = document.querySelector('.mobile-mega-menu .visually-hidden[role="status"]');

  if (!tabs.length || !contents.length) return;

  // --- Enhance images inside menu (lazy load) ---
  document.querySelectorAll('.mobile-mega-menu .mobile-mega-menu__images img').forEach(img => {
    img.loading = 'lazy';
    img.decoding = 'async';
  });

  // --- Remember last tab across drawer opens ---
  const STORAGE_KEY = 'mobileMegaMenu:lastTab';
  const initialTab = localStorage.getItem(STORAGE_KEY) || 'pottery';
  activateTab(initialTab, false); // no animation on first paint

  tabs.forEach(tab => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const target = tab.getAttribute('data-tab');
      activateTab(target, true);
      localStorage.setItem(STORAGE_KEY, target);
    });
  });

  function activateTab(name, announce = true) {
    // tabs
    tabs.forEach(t => {
      const isActive = t.getAttribute('data-tab') === name;
      t.classList.toggle('active', isActive);
      t.setAttribute('aria-selected', String(isActive));
      if (isActive) moveUnderline(t);
    });

    // contents
    contents.forEach(c => {
      const isMatch = c.getAttribute('data-content') === name;
      c.classList.toggle('active', isMatch);
      if (isMatch) c.removeAttribute('hidden'); else c.setAttribute('hidden', '');
    });

    if (announce && live) live.textContent = `${name} menu opened`;
  }

  // underline positioner
  function moveUnderline(activeTab) {
    if (!underline || !activeTab) return;
    const container = activeTab.parentElement.getBoundingClientRect();
    const rect = activeTab.getBoundingClientRect();
    underline.style.width = `${rect.width}px`;
    underline.style.left = `${rect.left - container.left}px`;
  }
  // update underline on resize
  window.addEventListener('resize', () => {
    const current = document.querySelector('.mobile-mega-menu__tabs .tab.active');
    if (current) moveUnderline(current);
  });

  // --- True accordion behavior (only one open at a time) ---
  document.querySelectorAll('.mobile-mega-menu__accordion').forEach(section => {
    section.addEventListener('toggle', (e) => {
      const opened = e.target;
      if (opened.tagName !== 'DETAILS' || !opened.open) return;
      // close siblings
      section.querySelectorAll('details[open]').forEach(d => { if (d !== opened) d.removeAttribute('open'); });
      // smooth scroll the summary into view
      opened.querySelector('summary')?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }, true);
  });

  // --- Fallback: hide theme nav below our mega menu when :has() is unavailable ---
  const navContainer = document.querySelector('.menu-drawer__navigation-container');
  const megaMenu = document.querySelector('nav.mobile-mega-menu');
  if (navContainer && megaMenu) {
    navContainer.classList.add('mmm-hide-nav');
  }
});
  // --- Drawer guard: block drawer toggle when tapping inside our mega menu ---
  if (navContainer && megaMenu) {
    ['pointerdown', 'click'].forEach(evt => {
      navContainer.addEventListener(evt, (e) => {
        if (megaMenu.contains(e.target)) {
          // Stop the event before any <summary> can react to it
          e.stopPropagation();
        }
      }, true); // capture phase
    });
  }
  // Prevent drawer <summary> from toggling when clicking inside our mega menu
  const navContainer = document.querySelector('.menu-drawer__navigation-container');
  const megaMenu = document.querySelector('nav.mobile-mega-menu');
  if (navContainer && megaMenu) {
    navContainer.addEventListener('click', (e) => {
      if (megaMenu.contains(e.target)) {
        // Block the default <summary> toggle, but DO NOT stop propagation.
        // Your snippet’s capture-phase handler will still see the click and switch views.
        e.preventDefault();
      }
    }, true); // capture phase so we beat <summary>'s default
  }
